<template>
  <div class="main">
    <hero-section />
    <!-- Section Linea de servicios -->
    <section-servicios />
    <!-- Section Video Empresa -->
    <section-video-empresa />
    <!-- Section Proyectos -->
    <section-proyectos />
    <!-- Section Quotes Testimonials -->
    <section-quotes />
    <!-- Section Alianzas -->
    <section-alianzas />
  </div>
</template>

<script>
  import HeroSection from "@/components/layout/hero-section.vue";
  import SectionServicios from "@/components/layout/body-sections/section-linea-servicios.vue";
  import SectionVideoEmpresa from "@/components/layout/body-sections/section-video-empresa.vue";
  import SectionProyectos from "@/components/layout/body-sections/section-proyectos.vue";
  import SectionQuotes from "@/components/layout/body-sections/section-quotes.vue";
  import SectionAlianzas from "@/components/layout/body-sections/section-alianzas.vue";

export default {
  name: 'AppHome',
  components: {
    HeroSection,
    SectionServicios,
    SectionVideoEmpresa,
    SectionProyectos,
    SectionQuotes,
    SectionAlianzas,
  }
}
</script>